// src/components/StatusBadge.tsx
// Colored status badge using variant from feature logic.

import { Badge } from '@react/components';
import type { BadgeProps } from '@react/components';

interface StatusBadgeProps {
  variant: string;
  label: string;
  size?: BadgeProps['size'];
  className?: string;
}

export function StatusBadge({ variant, label, size, className }: StatusBadgeProps) {
  const mapped = (
    variant === 'success' || variant === 'warning' || variant === 'error' ||
    variant === 'info' || variant === 'primary' || variant === 'secondary'
  )
    ? variant as BadgeProps['variant']
    : 'default';

  return <Badge variant={mapped} size={size} className={className}>{label}</Badge>;
}
